export default __webpack_public_path__ + "static/media/logo-bottom.94c5cae5.svg";